import { MapTo } from '@adobe/aem-react-editable-components';
import Image, { ImageEditConfig } from './Image';

export default MapTo('cob-corp-acquisition/components/creditonebank/image')(Image, ImageEditConfig);